<template>
    <router-link
        :to="{ name: 'activity', params: { activityId: content._id } }"
    >
        <community-content-card
            :content="content"
            @toggleState="$emit('toggleState')"
            @edit="$emit('edit')"
            @delete="$emit('delete')"
            @duplicate="$emit('duplicate')"
            @move="$emit('move')"
        />
    </router-link>
</template>
<script>
import CommunityContentCard from '@/components/CommunityContentCard';
export default {
    filters: {},
    components: {
        CommunityContentCard,
    },
    props: {
        content: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {};
    },

    computed: {},
    methods: {},
};
</script>

<style scoped lang="sass"></style>
